export default __webpack_public_path__ + "static/media/TokeOla.835f2e94.png";